import { Button } from '@amzn/awsui-components-react/polaris';
import { ClickDetail } from '@amzn/awsui-components-react/polaris/internal/events';

import styles from './ChoiceButton.module.css';

const ChoiceButton = ({
  children,
  onClick,
  className = '',
  id = '',
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  onClick: (event: CustomEvent<ClickDetail>) => void;
}) => (
  <div className={[styles.button, className].join(' ')}>
    <Button id={id} onClick={onClick} variant="normal" {...props}>
      {children}
    </Button>
  </div>
);

export default ChoiceButton;
